import { Photo } from "./photo";
import { User } from "./user";

export interface UserActivity { //' Profile  //UserActivityDto
    userName: string;
    displayName: string;
    bio?: string;
    photoUrl?: string;
    followersCount: number;
    followingCount: number;
    bFollowing: boolean;
    photos?: Photo[];
}

export class UserActivity implements UserActivity { //' Profile  
    constructor(user: User) {
        this.userName = user.displayName;
        this.displayName = user.displayName;
        this.photoUrl = user.image;
    }
}

// //.nn
// export class ProfileFormValues {
//     userName: string = '';
//     displayName: string = '';
//     bio?: string = '' ;
//     //photoUrl?: string = '';
//     //photos?: Photo[] = [];

//     constructor(profileFormValues?: ProfileFormValues) {
//         if(profileFormValues) {
//             this.userName = profileFormValues.userName;
//             this.displayName = profileFormValues.displayName;
//             this.bio = profileFormValues.bio;
//             //this.image = profileFormValues.image;
//             //this.photos = profileFormValues.photos;
//         }
//     }
// }

